import {fiverr_icon, github, linkedin, discord, upwork_icon} from "../assets";

export const navLinks = [
  {
    id: "technologies",
    title: "navbar.technologies",
  },
  // {
  //   id: "portfolio",
  //   title: "navbar.portfolio",
  // },
  {
    id: "gigs",
    title: "navbar.gigs",
  },
  {
    id: "about",
    title: "navbar.about",
  },
];

  export const apps = [
    {
      id: "app-1",
      title: "www.mateapp.ar",
      link: "https://www.mateapp.ar",
    },
  ];

  export const gigs = [
    {
      id: "gig-1",
      title: "gigs.title",
      link: "https://www.upwork.com/freelancers/mielnic"
    },
  ];

  export const footerLinks = [
    {
      title: "Projects",
      links: [
        {
          name: "MateApp",
          link: "https://www.mateapp.ar",
        },
      ],
    },
    {
      title: "Community",
      links: [
        {
          name: "Linkedin",
          link: "https://www.linkedin.com/in/paulo-mielnichuk",
        },
        {
          name: "Discord",
          link: "https://discord.gg/guv9ps4rUv",
        },
        {
          name: "Github",
          link: "https://github.com/mielnic",
        },
      ],
    },
    {
      title: "Business",
      links: [
        {
          name: "Upwork",
          link: "https://www.upwork.com/freelancers/~0165fa96a68fad6aca?viewMode=1",
        },
        {
          name: "Freelancer.com",
          link: "https://www.freelancer.com/u/pmielnichuk?frm=pmielnichuk&sb=t",
        },
      ],
    },
  ];
  
  export const socialMedia = [
    {
      id: "social-media-1",
      icon: linkedin,
      link: "https://www.linkedin.com/in/paulo-mielnichuk",
    },
    {
      id: "social-media-2",
      icon: github,
      link: "https://github.com/mielnic",
    },
    {
      id: "social-media-3",
      icon: discord,
      link: "https://discord.gg/guv9ps4rUv",
    },
    {
      id: "social-media-4",
      icon: upwork_icon,
      link: "https://www.upwork.com/freelancers/mielnic",
    },
  ];